import {
  DefenseBagTypes,
  DefenseBottomColorTypes,
  DefenseBottomTypes,
  DefenseCoatColorTypes,
  DefenseCoatTypes,
  DefenseEventTypes,
  DefenseGenderTypes,
  DefenseHatTypes,
  DefenseHumanDetectModeTypes,
  DefenseRecordBeardTypes,
  DefenseRecordEmotionTypes,
  DefenseRecordGlassesTypes,
  DefenseRecordMaskTypes,
  IDefenseEventNotifyHumanProps,
} from '../../../../services/Defense/Events/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import React from 'react';
import {
  convertBagType,
  convertBottomColor,
  convertBottomType,
  convertCoatColor,
  convertCoatType,
  convertEventType,
  convertGenderType,
  convertHatType,
  convertHumanDetectMode,
  convertRecordBeard,
  convertRecordEmotion,
  convertRecordGlasses,
  convertRecordMask,
} from '../../../../converters/Defense/ConverterDefense';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface IDefenseNotifyHumanInfosContentProps {
  event: IDefenseEventNotifyHumanProps;
}

const DefenseNotifyHumanInfosContent = ({
  event,
}: IDefenseNotifyHumanInfosContentProps) => {
  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  const formatDefenseDate = (date: Date) => {
    return dayjs(date);
  };

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />
        <TextFieldComponent
          label="ID do Canal"
          value={event?.channelId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Gênero do Humano"
          value={
            convertGenderType(event?.humanGender as DefenseGenderTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Idade do Humano"
          value={event?.humanAge ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Casaco"
          value={
            convertCoatType(event?.coat as DefenseCoatTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Cor do Casaco"
          value={
            convertCoatColor(event?.coatColor as DefenseCoatColorTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Calça"
          value={
            convertBottomType(event.trousers as DefenseBottomTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Cor da Calça"
          value={
            convertBottomColor(
              event.trousersColor as DefenseBottomColorTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Chapéu/Boné"
          value={convertHatType(event?.hat as DefenseHatTypes) ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Bolsa"
          value={convertBagType(event.bag as DefenseBagTypes) ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Emoção Facial"
          value={
            convertRecordEmotion(event?.emotion as DefenseRecordEmotionTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Óculos"
          value={
            convertRecordGlasses(event?.glasses as DefenseRecordGlassesTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Barba"
          value={
            convertRecordBeard(event?.beard as DefenseRecordBeardTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Máscara"
          value={
            convertRecordMask(event?.mask as DefenseRecordMaskTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora da Captura"
          value={formatDefenseDate(event?.captureTime)}
          readOnly={true}
        />
        <TextFieldComponent
          label="Modo de Detecção"
          value={
            convertHumanDetectMode(
              event?.detectMode as DefenseHumanDetectModeTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
    </Grid2>
  );
};

export default DefenseNotifyHumanInfosContent;
